import { render } from "./Alerts.vue?vue&type=template&id=3bbfdf0e&ts=true"
import script from "./Alerts.vue?vue&type=script&lang=ts"
export * from "./Alerts.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src1530414395/src/mediadept-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__